module.exports = __webpack_public_path__ + "img/icon-save-light.fc72201f.svg";